const moneyFormat = window.theme.moneyFormat;

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) { 
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_single':
            value = formatWithDelimiters(cents, 1);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

function preparePreview(file, container) {
    // Reset potential changes from previous uploads
    $(container).find('.mrk-progress').show();
    $(container).find('.mrk-upload').css('width', '0%');
    $(container).find('.mrk-error-message span').text('');

    // Display the file name and show the preview
    $(container).find('.mrk-filename span[data-mrk-name]').text(file.name);
    $(container).find('.preview-template').show();
}

function uploadFile(file, container) {
    var formData = new FormData();
    formData.append('file', file);

    $.ajax({
        url: 'https://jrsindustrial-files.com',
        type: 'POST',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function() {
            $('.mrk-steps-footer').addClass('loading');
        },
        xhr: function() {
            var xhr = new XMLHttpRequest();
            xhr.upload.addEventListener("progress", function(e) {
                if (e.lengthComputable) {
                    var percentComplete = (e.loaded / e.total) * 100;
                    $(container).find('.mrk-upload').css('width', percentComplete + '%');
                }
            });
            return xhr;
        },
        success: function(response) {
            // console.log(response);
            // response = JSON.parse(response);
            var url = 'https://jrsindustrial-files.com/' + response.filePath;
            $(container).find('.mrk-image img').attr('src', url); // Set the image source
            var logos = JSON.parse(localStorage.getItem('logos')) || [];
            logos.push(url);
            localStorage.setItem('logos', JSON.stringify(logos));
            $(container).find('.input-file-logo').val(url);
            $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
            $('.mrk-steps-footer').removeClass('loading');
            $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
        },
        error: function(jqXHR, textStatus, errorThrown) {
            $(container).find('.mrk-error-message span').text('Upload error: ' + textStatus);
            $(container).find('.mrk-progress').hide(); // Hide the progress bar on error
        }
    });
}
// customizer steps
function calculatePrice() {
    var sizes = $('.mrk-qty-item'),
        totalPrice = 0;
    const positions = $('[name="logo-position"]:checked');
    const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true : false;
    const positionsPrice = getAllPositionsPrice(isEmbroidery, positions);
    const logoTypePrice = Number($('[name="logo-type"]:checked').attr('price')) || 0;
    hideAndShowPositions(isEmbroidery);
    sizes.each(function() {
        var qty = Number($(this).val());
        var price = 0;
        if (qty > 0) {
            var variantPrice = Number($(this).attr('price'));
            var price = positionsPrice;
            var finalPrice = (price * qty) + (variantPrice * qty) + logoTypePrice;
            totalPrice = totalPrice + finalPrice;
        }
    });
    var positionsCount = $('.mrk-checked-position').length + $('[name="mrk-main-logo-position"]:checked').length;
    // $('#positionCount').html(positionsCount);
    $('.mrk-final-price').html(formatMoney(totalPrice));
}

function hideAndShowPositions(isEmbroidery) {
    if (isEmbroidery) {
        $('.mrk-step-2').addClass('mrk-embroidery-active').removeClass('mrk-print-active');
    } else {
        $('.mrk-step-2').addClass('mrk-print-active').removeClass('mrk-embroidery-active');
    }
}

function getAllPositionsPrice(isEmbroidery, positions) {
    var priceTotal = 0,
        price;
    positions.each(function() {
        if (isEmbroidery) {
            price = Number($(this).data('embroideryprice'));
        } else {
            price = Number($(this).data('printprice'));
        }
        priceTotal = priceTotal + price;
    })
    return priceTotal;
}

function getAllPositionsVariants(positions, qty, ParentVariantId) {
    var allPositionsItem = [],
        positionData = [];
    $('.mrk-hidden-field-item').map(function() {
        positionData.push(JSON.parse($(this).html()));
    })
  console.log(positionData)
    positionData.forEach(function(positionData, index) {
        var id;
        var isEmbroidery = positionData[`Application Method ${index + 1}`] == 'Embroidery';
        positions.each(function() {
            var logo = positionData[`Logo ${index + 1}`];
            var logo_id = positionData[`Logo Id ${index + 1}`];
            if ($(this).val() == positionData[`Position ${index + 1}`]) {
                if (isEmbroidery) {
                    id = Number($(this).data('embroideryvariant'));
                } else {
                    id = Number($(this).data('printvariant'));
                }
                allPositionsItem.push(buildItem(id, qty, ParentVariantId, logo, logo_id));
            }
        });
    });

    return allPositionsItem;
}

function updateContentInfo(image, color) {
    $('.mrk-popup-product-image').attr('src', image);
    $('.selected-color').text(color);
}

function UpdatePositionPrices() {
    const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true : false;
    var price;
    const positions = $('[name="logo-position"]');
    positions.each(function() {
        if (isEmbroidery) {
            price = Number($(this).data('embroideryprice'));
        } else {
            price = Number($(this).data('printprice'));
        }
        var formatted_price = formatMoney(price);
        $(this).next('.mrk-abs-price-position').html(`+${formatted_price}`)
    })
}

function checkItemInCart(variantId) {
    return new Promise((resolve, reject) => {
        $.get('/cart.js', function(response) {
            var cart = JSON.parse(response);
            for (let item of cart.items) {
                if (item.variant_id == variantId) {
                    resolve(true);
                    return;
                }
            }
            resolve(false);
        }).fail(function(error) {
            console.log("Error fetching cart:", error);
            reject(error);
        });
    });
}
async function addBulkItems() {
  console.log("addBulkItems is called...")
    var sizes = $('.mrk-qty-item'),
        totalPrice = 0;
    const positions = $('.logo-position-checkbox:checked')
  console.log(positions)
    var ids = [];

    sizes.each(function() {
        var currentIds = [];
        var qty = Number($(this).val());
        var ParentVariantId = Number($(this).data('variant-id'));
        if (qty > 0) {
            const mainVariant = buildMainVariant(ParentVariantId, qty);
            const positionsVariants = getAllPositionsVariants(positions, qty, ParentVariantId);
            console.log(positionsVariants)
            currentIds = currentIds.concat(positionsVariants);
            currentIds.push(mainVariant);
            ids = ids.concat(currentIds)
        }
    });

    var data = {
        items: ids
    };

    if (window.updates != undefined) {
        $('.mrk-loader-main').css('display', 'flex');
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
            updates: updates
        }, function(response) {
            var refreshCart = true;
            addItemToCart(data, refreshCart);
        }).fail(function() {
            // Handle error
            console.log('Error updating cart.');
        });
    } else {
        var refreshCart = false;
        addItemToCart(data, refreshCart);
    }
}

function addItemToCart(data, refreshCart) {
    console.log(data)
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data,
        dataType: 'json',
        beforeSend: function() {
            $('.mrk-loader-main').css('display', 'flex');
        },
        success: function(resp) {
            if (refreshCart == 'notification') {
                initNotification(resp);
            } else if (refreshCart) {
                $('.mrk-customizer-cart').hide()
                updateCart();
            } else
                location.pathname = '/cart'
        }
    });
}

function buildMainVariant(ParentVariantId, qty) {
    var properties = {};
    $('.mrk-hidden-field-item').each(function() {
        var obj = JSON.parse($(this).html());
        $.each(obj, function(key, value) {
            properties[key] = value;
        });
    });
    return ({
        quantity: qty,
        id: ParentVariantId,
        properties
    })
}

function buildItem(id, qty, ParentVariantId, logo, logo_id) {
    if (ParentVariantId === '') {
        return {
            quantity: qty,
            id
        };
    } else {
        let properties = {
            '_ParentVariant': ParentVariantId
        };

        if (logo !== '') {
            properties['Logo'] = logo;
            properties['Logo Id'] = logo_id;
        }

        return {
            quantity: qty,
            id,
            properties: properties
        };
    }
}



// new js code  
function getLogoDetails(index,logoType,checkedLogo) {
    var logo = {};

if (document.querySelector(".same-logo-label").classList.contains("selected")){
    if (logoType == 'Upload Your Logo') {
        logo = {
            [`Logo ${index}`]: $('.input-file-logo-original[name="properties[Uploaded Logo]"]').val(),
            [`Note ${index}`]: $('.customerNotesFilesUploadedLogo-original').val()
        };
    } else if (logoType == 'Existing Logo') {
        logo = {
            [`Logo ${index}`]: $('.input-file-logo-existing-original[name="properties[Existing Logo]"]').val(),
            [`Note ${index}`]: $('.customerNotesFilesExisting-original').val()
        };
    } else if (logoType == 'Text Logo') {
        logo = {
            [`Logo Text ${index}`]: $('.logoText-original-1[name="properties[Text Line]"]').val(),
            [`Logo Text 2 ${index}`]: $('.logoText-original-2[name="properties[Text Line 2]"]').val(),
            [`Logo Text 3 ${index}`]: $('.logoText-original-3[name="properties[Text Line 3]"]').val(),
            [`Logo Text 4 ${index}`]: $('.logoText-original-4[name="properties[Text Line 4]"]').val(),
            [`Logo Color ${index}`]: $('.logoColor-original').val(),
            [`Logo Font ${index}`]: $('.font-family-original').val(),
            [`Note ${index}`]: $('.notesLogoText-original').val()
        };
    }  
} 
else {
  console.log(checkedLogo)
  let idxPosition = checkedLogo.firstElementChild.getAttribute("name").slice(-1);
    if (logoType == 'Upload Your Logo') {
        logo = {
            [`Logo ${index}`]: document.querySelector(`.mrk-step-upload-your-logo-position-${idxPosition}`).querySelector('input[name="properties[Uploaded Logo]"]').value,
            [`Note ${index}`]: document.querySelector(`.mrk-step-upload-your-logo-position-${idxPosition}`).querySelector('textarea.customerNotesFilesUploadedLogo-position').value
        };
    } else if (logoType == 'Existing Logo') {
        logo = {
            [`Logo ${index}`]: document.querySelector(`.mrk-step-existing-logo-position-${idxPosition}`).querySelector('input[name="properties[Existing Logo]"]').value,
            [`Note ${index}`]: document.querySelector(`.mrk-step-existing-logo-position-${idxPosition}`).querySelector('textarea.customerNotesFilesExisting-position').value
        };
    } else if (logoType == 'Text Logo') {
      console.log(document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('textarea.notesLogoText-position').value)
        logo = {
            [`Logo Text ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-1').value,
            [`Logo Text 2 ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-2').value,
            [`Logo Text 3 ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-3').value,
            [`Logo Text 4 ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-4').value,
            [`Logo Color ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('.logoColor-position').value,
            [`Logo Font ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('.font-family-position').value,
            [`Note ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('textarea.notesLogoText-position').value
        };
    }   
}
  
    return logo;
}

function addHiddenField(index, properties) {
    var hiddenField = $('<div class="mrk-hidden-field-item"></div>').attr('data-index', index);
    $(hiddenField).html(JSON.stringify(properties));
    console.log(JSON.stringify(properties), properties);
    $('.mrk-hidden-fields').append(hiddenField);
}

function updateMeta() {

if (document.querySelector(".same-logo-label").classList.contains("selected")){
console.log("updateMeta() is called...")
  
let allCheckedLogoPositions = document.querySelectorAll(".logo-position-checked");
  
allCheckedLogoPositions.forEach((el, idx) => {
  let checkedLogo = el;
  let indexValue = idx + 1;
  let applicationMethod;
  let logoVariant;
  checkedLogo.querySelectorAll(".application-method-container-input").forEach((inputEl) => {
    if (inputEl.checked) {
      applicationMethod = inputEl.value;
    }
  })
  if (applicationMethod == "Print") {
    logoVariant = checkedLogo.firstElementChild.getAttribute("data-printvariant");
  }
  else if (applicationMethod == "Embroidery") {
    logoVariant = checkedLogo.firstElementChild.getAttribute("data-embroideryvariant");
  }
  let position = checkedLogo.firstElementChild.value;
  let logoType = $('[name="logo-type"]:checked').val();
  let logoId = Math.floor(Math.random() * (999998 + 1));
  let logoDetails = getLogoDetails(indexValue,logoType);
  let logo_url = logoDetails[`Logo ${indexValue}`];
  if (logoType == 'Existing Logo' && window.logoId && logo_url == window.logoUrl) {
    logoId = window.logoId;
  } else {
    window.logoId = logoId;
    window.logoUrl = logo_url;
  }
  var genericProperties = {
    [`Application Method ${indexValue}`]: applicationMethod,
    [`Position ${indexValue}`]: position,
    [`Logo Type ${indexValue}`]: logoType,
    [`Logo Id ${indexValue}`]: logoId,
    [`_logoVariant${indexValue}`]: logoVariant
  };
  var properties = Object.assign({}, genericProperties, logoDetails);
  addHiddenField(indexValue, properties);
})
}
else {
  
let allCheckedLogoPositions = document.querySelectorAll(".logo-position-checked");
  
allCheckedLogoPositions.forEach((el, idx) => {
  let checkedLogo = el;
  let indexValue = idx + 1;
  let applicationMethod;
  let logoVariant;
  checkedLogo.querySelectorAll(".application-method-container-input").forEach((inputEl) => {
    if (inputEl.checked) {
      applicationMethod = inputEl.value;
    }
  })
  if (applicationMethod == "Print") {
    logoVariant = checkedLogo.firstElementChild.getAttribute("data-printvariant");
  }
  else if (applicationMethod == "Embroidery") {
    logoVariant = checkedLogo.firstElementChild.getAttribute("data-embroideryvariant");
  }
  let position = checkedLogo.firstElementChild.value;
  let logoType = el.getAttribute("data-logo-type");
  let logoId = Math.floor(Math.random() * (999998 + 1));
  let logoDetails = getLogoDetails(indexValue,logoType,checkedLogo);
  let logo_url = logoDetails[`Logo ${indexValue}`];
  if (logoType == 'Existing Logo' && window.logoId && logo_url == window.logoUrl) {
    logoId = window.logoId;
  } else {
    window.logoId = logoId;
    window.logoUrl = logo_url;
  }
  var genericProperties = {
    [`Application Method ${indexValue}`]: applicationMethod,
    [`Position ${indexValue}`]: position,
    [`Logo Type ${indexValue}`]: logoType,
    [`Logo Id ${indexValue}`]: logoId,
    [`_logoVariant${indexValue}`]: logoVariant
  };
  var properties = Object.assign({}, genericProperties, logoDetails);
  addHiddenField(indexValue, properties);
})  
}  
      
    // var index = $('.mrk-hidden-fields .mrk-hidden-field-item').length + 1;
    // var logoDetails = getLogoDetails(index),
    //     applicationMethod = $('[name="application-type"]:checked').val(),
    //     logoVariant = $('[name="logo-type"]:checked').attr('variant'),
    //     position = $('.mrk-position-item input:checked').val(),
    //     logoType = $('[name="logo-type"]:checked').val(),
    //     logoId = Math.floor(Math.random() * (999998 + 1)),
    //     logo_url = logoDetails[`Logo ${index}`];
    // console.log(logoDetails)
    // if (logoType == 'Existing Logo' && window.logoId && logo_url == window.logoUrl) {
    //     logoId = window.logoId;
    // } else {
    //     window.logoId = logoId;
    //     window.logoUrl = logo_url;
    // }

    // var genericProperties = {
    //     [`Application Method ${index}`]: applicationMethod,
    //     [`Position ${index}`]: position,
    //     [`Logo Type ${index}`]: logoType,
    //     [`Logo Id ${index}`]: logoId,
    //     [`_logoVariant${index}`]: logoVariant
    // };
    // var properties = Object.assign({}, genericProperties, logoDetails);
    // addHiddenField(index, properties);
    // Disable current checked positions
    // not needed now since all logos can be selected at once, this is to show already selected message on logos so user can not select same position again
    // $('.mrk-position-item input:checked').each(function() {
    //     $(this).prop('disabled', true).parents('.mrk-position-item').addClass('mrk-checked-position');
    // });
}


// this is not needed as it was being used to handle the addition of another logo
function handleLogo() {
    $('.mrk-add-another-logo').on('click', function() {
        updateMeta();
        $('.mrk-close-btn').click();
        initExistingLogos();
        // Reset position selections
        $('[name="mrk-main-logo-position"]').prop('checked', false);

        // Reset logo type and details
        $('[name="logo-type"]').prop('checked', false);
        $('[name="properties[Uploaded Logo]"]').val('');
        $('#customerNotesFilesUploadedLogo').val('');
        $('[name="properties[Existing Logo]"]').val('');
        $('#customerNotesFilesExisting').val('');
        $('[name="properties[Text Line]"]').val('');
        $('#logoColor').val('');
        $('#font-family').val('');
        $('#notesLogoText').val('');
        // $('#previewDiv').text('JRS');
        $('#logoText').val('JRS');
        $('#previewDivLine1').html('JRS');
        $('#previewDivLine2').html('');
        $('#previewDivLine3').html('');
        $('#previewDivLine4').html('');
        window.mrknavigateTo(0);
    });
}

function initPopup() {
  // this is kind of not related
    $('.mrk-product-csutomizer input').change(function(e) {
        e.preventDefault();
        calculatePrice()
    });
  // this is kind of not related
    $('[name="application-type"]').change(function(e) {
        e.preventDefault();
        UpdatePositionPrices();
    });
  // related, then final atc is clicked
    $('.mrk-final-add-to-cart').click(function(e) {
        e.preventDefault();
      // updateMeta() is important
        updateMeta();
        const positionsCount = $('.mrk-checked-position').length + $('.logo-position-checkbox:checked').length;
        if (positionsCount == 0) {
            alert('Select Positions!');
            window.mrknavigateTo(1);
            return;
        }
        const logoType = $('[type="radio"]:checked');
        if (logoType.length == 0) {
            alert('Select Logo Type!');
            window.mrknavigateTo(2);
            return;
        }
        addBulkItems();
    });
    multiStepForm($(".mrk-multistep"), {
        defaultStep: 0
    });
    $('.popup__close.customizer-popup').click(function(e) {
        e.preventDefault();
        if ($(this).parents('.mrk-customizer-cart').length)
            $('.mrk-customizer-cart').hide()
        else
            $('.mrk-customizer-popup-form .popup-overlay').removeClass('show')
    });
    $('.mrk-open-popup').click(function(e) {
        e.preventDefault();
        var sizes = $('.mrk-qty-item');
        var count = 0;
        sizes.each(function() {
            if ($(this).val() > 0)
                count++
        });
        if (count) {
            calculatePrice();
            $('.mrk-customizer-popup-form .popup-overlay').addClass('show');
            const color = $('[name="options[Color]"]:checked').val() || $('[name="options[Colour]"]:checked').val();
            const image = $('.productGallery .swiper-slide-active img').attr('src');
            updateContentInfo(image, color);
        } else {
            alert('Please select Size')
        }

    });

    // On change of text input
    $('#logoText').on('input', function() {
        // $('#previewDiv').html($(this).val());
        $('#previewDivLine1').html($(this).val());
        if ($(this).val() != '') {
            $('.mrk-steps-footer').removeClass('mrk-disable-btn');
        } else {
            $('.mrk-steps-footer').addClass('mrk-disable-btn');
        }

    });
    $('#logoText2').on('input', function() {
        $('#previewDivLine2').html($(this).val());
    });
    $('#logoText3').on('input', function() {
        $('#previewDivLine3').html($(this).val());
    });
    $('#logoText4').on('input', function() {
        $('#previewDivLine4').html($(this).val());
    });

    // On change of font dropdown
    $('#font-family').change(function() {
        const fontFamily = $(this).val();
        $('#previewDiv').css('font-style', fontFamily);
    });

    // On change of color dropdown
    $('#logoColor').change(function() {
        const color = $(this).val();
        const bg = $('#logoColor option:selected').attr('bg') || 'black';
        $('#previewDiv').css('color', color).css('background', bg);
    });
    $('.mrk-close-btn').click(function() {
        $('.input-file-logo').val('');
        $('[data-mrk-thumbnail]').attr('src', '');
        $('.preview-template').hide();
        $('.hiddenFileInput').val('').change();
    });
    // uploader
    // When a file is chosen using the file input, upload it
    $('.hiddenFileInput').change(function() {
        var container = $(this).parents('.mrk-step-upload-logo');
        var file = this.files[0];
        if (file) {
            preparePreview(file, container);
            uploadFile(file, container);
        }
    });


    // Handle input change 
    function handleInputChange(input) {
        const container = $(input).parents('.mrk-step-existing-logo'); // Find the parent tab container
        const file = $(input).val(); // Get the value (URL)

        // Display the file name and show the preview
        $(container).find('.input-file-logo').val(file);
        console.log($(container).find('.input-file-logo'), file, $(container));
        $(container).find('.mrk-filename span[data-mrk-name]').text(file.replace('https://jrsindustrial-files.com/uploads/', ''));
        $(container).find('.preview-template').show();
        $(container).find('.mrk-image img').attr('src', file);
        $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
        $('.mrk-steps-footer').removeClass('loading');
        $('.mrk-steps-footer').removeClass('mrk-disable-btn');
    }

    // Attach change event listener to dynamically created inputs
    $(document).on('change', '.mrk-existing-logo-item', function() {
        handleInputChange($('.mrk-existing-logo-item:checked'));
    });
    initExistingLogos();
    handleLogo()
}

function initNotification(resp) {
    const items = resp.items;
    // 1. Get the image of the first item
    var image = items[0].image;
    // 2. Get the value of the color option
    var selectedColor = $('[name="options[Color]"]:checked').val() || $('[name="options[Colour]"]:checked').val();
    // 3. Loop through all items to get all sizes and push into array
    var sizes = [];
    items.forEach(function(item) {
        if ($('[name="options[Color]"]:checked').length) {
            var color = item.options_with_values.find(option => option.name === "Color").value
        } else {
            var color = item.options_with_values.find(option => option.name === "Colour").value
        }
        if (color === selectedColor) {
            var size = item.options_with_values.find(option => option.name === "Size").value;
            if (sizes.indexOf(size) === -1) { // ensure no duplicates
                sizes.push(size);
            }
        }
    });

    // 4. Loop through the sizes array and log them
    var sizes = sizes.join(', ');
    $('.popup-color-name').html(selectedColor);
    $('.popup-size-name').html(sizes);
    $('cart-notification-mrk .cart-notification-product__image img').attr('src', image);
    $('body').addClass('js-cart-open');
    $('[data-submit-button] [data-submit-button-text]').removeClass('loading');
    $('.loading-overlay__spinner').addClass('hidden');
    $('cart-notification-mrk [type="close"]').click(function(e) {
        e.preventDefault();
        $('body').removeClass('js-cart-open');
    });
}

function initExistingLogos() {
    // Parse the stored logos from localStorage
    const logos = JSON.parse(localStorage.getItem('logos')) || [];

    // Generate the HTML and append it to a container
    // const $container = $('.mrkexisting-logo-select-original'); // Replace with your actual container selector
    if (logos.length) {
        $('.mrk-existing-logo-wrapper').show();
        $('.mrk-existing-logo-selector').show()
    }
  
document.querySelectorAll(".mrkexisting-logo-select").forEach((el, idxPosition) => {
  if (logos.length) {
    el.innerHTML = "";
  }

  logos.forEach((logo, index) => {
    let logoItem = document.createElement("div");
    logoItem.classList.add("logo-item")
    logoItem.innerHTML = `
        <input type="radio" name="mrk-existing-logo" value="${logo}" class="mrk-existing-logo-item" id="mrk-existing-logo-${index}-${idxPosition}" />
        <label for="mrk-existing-logo-${index}-${idxPosition}">
          <img src="${logo}" class="mrk-exiting-logo-image" />
        </label>
    `;
    el.append(logoItem);
  });
})
  
}

// this is responsible only if no logos are selected
function initSingleAdd() {
    $('product-form-mrk form').submit(function(e) {
        e.preventDefault();
        var sizes = $('.mrk-qty-item');
        var ids = [];
        sizes.each(function() {
            var qty = Number($(this).val());
            var variantId = Number($(this).data('variant-id'));
            if (qty > 0) {
                console.log($(this))
                const variantObj = buildItem(variantId, qty, '', '', '');
                ids.push(variantObj);
            }
        });
        var data = {
            items: ids
        }
        if (ids.length == 0) {
            alert('Please select Size')
            return;
        }
        $(this).find('[data-submit-button] [data-submit-button-text]').addClass('loading');
        $(this).find('.loading-overlay__spinner').removeClass('hidden');
        addItemToCart(data, 'notification');
    });
}

// if there is no mrk-customizer-cart then popup is called - kind of related
if (!$('.mrk-customizer-cart').length)
    initPopup();

// if there is quantity selector available then this function will be called - not related to us
if ($('.mrk-qty-item').length) {
    initSingleAdd()
}

document.querySelectorAll('input[name="mrk-existing-logo"]').forEach((el) => {
  el.addEventListener("input", () => {
    document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
  })
})

document.querySelectorAll('input[name="properties[Text Line]"]').forEach((el) => {
  el.addEventListener("input", () => {
    document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
  })
})

document.querySelectorAll('input[name="properties[Text Line 2]"]').forEach((el) => {
  el.addEventListener("input", () => {
    document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
  })
})

document.querySelectorAll('input[name="properties[Text Line 3]"]').forEach((el) => {
  el.addEventListener("input", () => {
    document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
  })
})

document.querySelectorAll('input[name="properties[Text Line 4]"]').forEach((el) => {
  el.addEventListener("input", () => {
    document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
  })
})

let allLogoSelectionIcons = document.querySelectorAll(".selected-position-logo-style-icon-position");
allLogoSelectionIcons.forEach((el)=>{
  el.addEventListener("click",()=>{
    let logoTypeValue = el.firstElementChild.value;
    let positionName = el.parentElement.parentElement.getAttribute("data-position-name");
    document.querySelector(`.logo-position-checked[data-logo-position="${positionName}"]`).setAttribute("data-logo-type",logoTypeValue)
  })
})